module.exports = __webpack_public_path__ + "img/Promotion Images.c86f40ce.png";